import React, { useState } from 'react'
import SelectInput from "../../MainAddComps/Forms/CustomInputs/SelectInput"
import TextInput from "../../MainAddComps/Forms/CustomInputs/TextInput"
import Swal from "sweetalert2/dist/sweetalert2.all"

function CarEditFormInline(params) {
    const [name, setName] = useState("");
    const [plate, setPlate] = useState("");
    const [providerName, setProviderName] = useState("");
    const [providerId, setProviderId] = useState("");

    const handleName = (val) => {
        setName(val)
    }
    const handlePlate = (val) => {
        setPlate(val)
    }
    const handleProvider = (val) => {
        setProviderName(val.label)
        setProviderId(val.value)
    }
    const handleSubmit = () => {
        let data = { id: params.id, name: name, plate: plate, provider_name: providerName, provider_id: providerId }
        api.editCar(data).then(res => {
            console.log("edit res.data", res.data)
            if (res.data[0] == "success") {
                Swal.fire("Başarılı", "Düzenleme işleminiz başarıyla gerçekleşmiştir", "success").then((result) => {
                    if (result.isConfirmed) {
                        params.endEditing(data, params.id);
                    }
                })
            } else {
                Swal.fire("Başarısız", "Bir hatayla karşılaşıldı", "error")
            }
        }).catch(err => {
            console.log("edit err", err)
            Swal.fire("Başarısız", "Bir hatayla karşılaşıldı", "error")
        })
    }
    const handleCancel = (e) => {
        e.preventDefault()
        params.endEditing("endEdit", 0);
    }
    let row = params.row
    return (row ?
        <tr>
            <th className="table-id"># {params.id}</th>
            <td>
                <TextInput type="text" passValue={handleName} initialValue={row["name"]} />
            </td>
            <td>
                <TextInput type="text" passValue={handlePlate} initialValue={row["plate"]} />
            </td>
            <td className="w-25">
                <SelectInput type="provider" passValue={handleProvider} value={{ value: row["provider_id"], label: row["provider_name"] }} />
            </td>
            <td className="table-islem1">
                <div className="p-2">
                    <a href="#" onClick={handleSubmit} className="btn btn-sm btn-primary w-100 mb-2">Onayla</a>
                    <a href="#" onClick={handleCancel} className="btn btn-sm btn-danger w-100 mb-2">İptal</a>
                </div>
            </td>
        </tr> : null
    )
}

export default CarEditFormInline
